import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import HomePage from "./pages/HomePage";
import SubmitReviewPage from "./pages/SubmitReviewPage";
import ViewReviewsPage from "./pages/ViewReviewsPage";
import AboutPage from "./pages/AboutPage";
import TermsOfService from "./pages/TermsOfService";
import "./App.css";
import "./styles/NavBar.scss";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import SkipToMain from "./components/SkipToMain";
import PrivacyNotice from "./pages/PrivacyNotice";
import MapPage from "./pages/MapPage";
import { mainAreaBackground } from "./theme";

const App: React.FC = () => {
  const theme = useTheme();
  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
      }}
    >
      <Router>
        <div
          className="app-shell"
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
          }}
        >
          <SkipToMain />
          <NavBar />
          <div
            className="main-content"
            style={{
              flex: 1,
              background: mainAreaBackground(theme),
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/submit" element={<SubmitReviewPage />} />
              <Route path="/reviews" element={<ViewReviewsPage />} />
            <Route path="/map" element={<MapPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/privacy" element={<PrivacyNotice />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </Router>
    </div>
  );
};

export default App;
